export default {
    namespaced: true,

    state: {
        companyChanged: false,
    },

    getters: {
        companyChanged: state => state.companyChanged,
    },

    mutations: {
        SET_CHANGED(state, item) {
                state.companyChanged = item
        },
    },

    actions: {
        setChanged({ commit }, item) {
            commit('SET_CHANGED', item)
        },
    },
}
